import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import "./SelectPrasadPackageDilog.scss";
import { truncateToTwoDecimals } from "../../utils/HelperFunctions";
import { useTranslation } from "react-i18next";
import { LOCALIZATION } from "../../utils/localization";

interface SelectPrasadPackageDilogProps {
  open: boolean;
  selectedPrasad: any;
  onClose: () => void;
  handleSelectPrasadPkg: (pkgId:String, selectedPrasad:any)=> any;
}

const SelectPrasadPackageDilog: React.FC<SelectPrasadPackageDilogProps> = ({
  open,
  selectedPrasad,
  onClose,
  handleSelectPrasadPkg,
}) => {
  const { t } = useTranslation();
  const [selectedPackageId, setSelectedPackageId] = useState<string>("");

  const handlePackageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedPackageId(event.target.value);
  };
  const handleSave = () => {
    if(selectedPackageId){
      handleSelectPrasadPkg(selectedPackageId,selectedPrasad);
      setSelectedPackageId("");
      onClose();
    }
  };

  const handleClose = () =>{
    setSelectedPackageId("")
    onClose();
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <div className="selectPrasadDialog">
        <DialogTitle className="dialogTitle">{t(LOCALIZATION.Select_Prasad_Package)}</DialogTitle>

        <DialogContent>
          <Box className="imageBox">
            <img src={selectedPrasad?.image} alt="Prasad" />
            <Box className="imageText">
              <h3 className="prasadTitle">{selectedPrasad?.name}</h3>
              <p className="prasadDescription">{selectedPrasad?.itemDescription}</p>
            </Box>
          </Box>

          <FormControl component="fieldset" className="formControl">
            <FormLabel component="legend">{t(LOCALIZATION.Choose_Package)}</FormLabel>
            <RadioGroup
              value={selectedPackageId}
              onChange={handlePackageChange}
              name="package-selection"
            >
              {selectedPrasad?.packages?.map((pkg: any) => (
                <FormControlLabel
                  key={pkg.packageId}
                  value={pkg.packageId}
                  control={<Radio />}
                  label={
                    <span className="packageLabel">
                      {pkg?.value} {pkg?.measurement} - {t(LOCALIZATION.Price)} ₹{truncateToTwoDecimals(pkg?.priceInfo?.finalPrice)}
                    </span>
                  }                  
                />
              ))}
            </RadioGroup>
          </FormControl>
        </DialogContent>

        <DialogActions className="actions">
          <Button onClick={onClose} color="primary" variant="outlined">
            {t(LOCALIZATION.Close)}
          </Button>
          <Button onClick={handleSave} color="primary" variant="contained">
            {t(LOCALIZATION.ADD)}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default SelectPrasadPackageDilog;
